import { Routes } from '@angular/router';

import { LoadMfeGuard } from '@digital-platform/rs-classic/ui';

export const ROUTES: Routes = [
  {
    path: '',
    canActivate: [LoadMfeGuard],
    data: {
      classicMfe: 'classic',
    },
    loadComponent: () =>
      import('./classic-host/classic-host.component').then(
        (c) => c.ClassicHostComponent
      ),
  },
];
